import { usePage } from "@inertiajs/react"
import { AppShell } from "@/components/layout/app-shell"
import { PageHeader } from "@/components/layout/page-header"
import type { SharedProps } from "@/types/inertia"

// PR #1: scaffold-only landing. Mock metrics; live data lands in PR #3
// once Portal::AgentsController is wired up.
export default function DashboardIndex() {
  const { props } = usePage<SharedProps>()
  const user = props.current_user
  const company = props.current_company

  return (
    <AppShell>
      <PageHeader
        eyebrow="Dashboard"
        title="Welcome back"
        subtitle={user ? `Signed in as ${user.email}` : undefined}
        actions={
          // 44px touch target on mobile; full-width on phones so the CTA
          // is reachable with one thumb without the page header collapsing.
          <button className="inline-flex w-full min-h-11 items-center justify-center rounded-control bg-brand-red px-4 text-sm font-medium text-white shadow-redGlow transition hover:bg-brand-redDeep sm:w-auto">
            New agent
          </button>
        }
      />

      {/* KPI tiles: 1-col on phone, 2 at sm:, 3 at md:. */}
      <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 md:gap-4">
        <Card title="Active agents"  value="—" hint="Live count lands in PR #3" />
        <Card title="Open tickets"   value="—" hint="Escalated convos queue" />
        <Card title="Avg. response"  value="—" hint="Computed from invocations" />
      </section>

      {/* Welcome banner — text-only; tighter padding on phone. */}
      <section className="rounded-card border border-border bg-app-panel p-4 shadow-card sm:p-6">
        <div className="text-sm text-app-muted">Tenant</div>
        <div className="mt-1 text-2xl font-semibold">
          {company?.name ?? "No company assigned"}
        </div>
        <p className="mt-3 text-sm text-app-muted">
          This is the Valet.red Support OS scaffold. Sidebar nav, design tokens,
          and Inertia routing are wired. Real agent / ticket data ships in
          PR #2 (mock) and PR #3 (live).
        </p>
      </section>
    </AppShell>
  )
}

type CardProps = { title: string; value: string; hint: string }
function Card({ title, value, hint }: CardProps) {
  return (
    <div className="rounded-card border border-border bg-app-panel p-4 shadow-card sm:p-5">
      <div className="text-sm text-app-muted">{title}</div>
      <div className="mt-2 text-3xl font-semibold tracking-tight">{value}</div>
      <div className="mt-1 text-xs text-app-subtle">{hint}</div>
    </div>
  )
}
